// Remembers the open tab per block so it survives the buybox section
// re-render on variant change (Section Rendering API replaces the markup).
const activeTabByBlock = new Map();

class NSSBuyboxTabs extends HTMLElement {
  constructor() {
    super();

    this.debug = false;

    this.els = {};
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Buybox Tabs] Connected.`);

    this.blockId = this.getAttribute(`data-block-id`);
    this.els.tabs = Array.from(this.querySelectorAll(`[nss-tabs-tab]`));
    this.els.panels = Array.from(this.querySelectorAll(`[nss-tabs-panel]`));

    if (!this.els.tabs.length) return;

    this.addEventListener(`click`, this.handleClick.bind(this));
    this.addEventListener(`keydown`, this.handleKeydown.bind(this));

    const remembered = activeTabByBlock.get(this.blockId);
    if (remembered && this.getTab(remembered)) {
      this.select(remembered, { focus: false });
    }
  }

  getTab(id) {
    return this.querySelector(`[nss-tabs-tab="${id}"]`);
  }

  getPanel(id) {
    return this.querySelector(`[nss-tabs-panel="${id}"]`);
  }

  handleClick(e) {
    const tabEl = e.target.closest(`[nss-tabs-tab]`);
    if (!tabEl || !this.contains(tabEl)) return;

    this.select(tabEl.getAttribute(`nss-tabs-tab`), { focus: false });
  }

  handleKeydown(e) {
    const tabEl = e.target.closest(`[nss-tabs-tab]`);
    if (!tabEl || !this.contains(tabEl)) return;

    const index = this.els.tabs.indexOf(tabEl);
    if (index === -1) return;

    let nextIndex = null;

    switch (e.key) {
      case `ArrowRight`:
        nextIndex = (index + 1) % this.els.tabs.length;
        break;
      case `ArrowLeft`:
        nextIndex = (index - 1 + this.els.tabs.length) % this.els.tabs.length;
        break;
      case `Home`:
        nextIndex = 0;
        break;
      case `End`:
        nextIndex = this.els.tabs.length - 1;
        break;
      default:
        return;
    }

    e.preventDefault();
    this.select(this.els.tabs[nextIndex].getAttribute(`nss-tabs-tab`), { focus: true });
  }

  select(id, options = {}) {
    const tabEl = this.getTab(id);
    const panelEl = this.getPanel(id);
    if (!tabEl || !panelEl) return;

    this.els.tabs.forEach((el) => {
      const isActive = el === tabEl;
      el.classList.toggle(`nss-active`, isActive);
      el.setAttribute(`aria-selected`, isActive ? `true` : `false`);
      el.setAttribute(`tabindex`, isActive ? `0` : `-1`);
    });

    this.els.panels.forEach((el) => {
      el.classList.toggle(`nss-active`, el === panelEl);
    });

    if (this.blockId) activeTabByBlock.set(this.blockId, id);

    if (options.focus) tabEl.focus();

    if (this.debug) console.log(`[NSS][Buybox Tabs] Selected tab:`, id);
  }
}

const elementName = `nss-buybox-tabs`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSBuyboxTabs);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
